import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import TimeoutUtility from "../../contexts/TimeoutUtility";
import { validateField } from "../../contexts/Utils";
import { editPayment, getAccList, GetPaymentById } from "../../api";
import { Header, Button } from "../../components";
import "../../styles/AddPart.css";
import { Container, Col, Row } from "react-bootstrap";
import TextAreaField from "../../components/TextAreaField";
import DoubleField from "../../components/DoubleField";
import SelectField from "../../components/SelectField";
import { showSuccessToast, showErrorToast } from "../../components/ToastMesg";

const EditReceipt = () => {
  const navigate = useNavigate();
  const param = useParams();
  const payment_id = param.r_id;
  const [accountFrom, setAccountFrom] = useState([]);
  const [accountTo, setAccountTo] = useState([]);
  const [formData, setFormData] = useState({
    account_from: "select",
    account_to: "select",
    amount: "0.0",
    notes: "",
  });
  const [errors, setErrors] = useState({});
  const [loadBtn, setLoadBtn] = useState(false);

  const formatCurrency = (number) => {
    return number.toLocaleString("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: 2,
    });
  };

  const handleBackClick = () => {
    TimeoutUtility.resetTimeout();
    navigate("/Receipt");
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    const error = validateField(name, value, name);
    setErrors((prev) => ({ ...prev, [name]: error }));
  };

  const handleSelectChange = (option, e) => {
    if (option && option.value) {
      setFormData((prev) => ({ ...prev, [e.name]: option }));
      const error = validateField(e.name, option, e.name);
      setErrors((prev) => ({ ...prev, [e.name]: error }));
    } else setFormData((prev) => ({ ...prev, [e.name]: "select" }));
  };

  const handleSubmit = async (e) => {
    TimeoutUtility.resetTimeout();
    e.preventDefault();
    setLoadBtn(true);

    const newErrors = {};
    Object.keys(formData).forEach((key) => {
      const error = validateField(key, formData[key], key);
      if (error) newErrors[key] = error;
    });
    if (
      !newErrors["account_from"] &&
      formData.account_from.value === formData.account_to.value
    )
      newErrors["account_from"] = "Choose a different Account!";
    if (
      !newErrors["amount"] &&
      !newErrors["account_from"] &&
      parseFloat(formData.amount) > parseFloat(formData.account_from.balance)
    )
      newErrors["amount"] = "Amount should be less than Account balance!";
    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) {
      setLoadBtn(false);
      return;
    }
    try {
      const response = await editPayment(
        payment_id,
        formData.account_from.value,
        formData.account_to.value,
        11,
        formData.amount,
        null,
        formData.notes,
      );
      if (response.success) {
        showSuccessToast("Success!", "Receipt Update Successfully");
        navigate("/Receipt");
      } else
        showErrorToast(
          "Error!",
          "Receipt Failed to Update\n\n" + response.message,
        );
    } catch (err) {
      showErrorToast("Error!", "Receipt Failed to Update");
    } finally {
      setLoadBtn(false);
    }
  };

  useEffect(() => {
    async function fetchData() {
      if (payment_id) {
        TimeoutUtility.resetTimeout();
        let paymentRes = null;
        let accFrom = "select";
        let accTo = "select";
        await GetPaymentById(payment_id)
          .then((result) => {
            paymentRes = result;
          })
          .catch((err) => console.log(err.message));
        await getAccList(paymentRes.data.store_id)
          .then((resp) => {
            const accOptions = resp.data.map((item) => ({
              label: item.name,
              value: item.account_id,
              balance: item.balance,
              open_datetime: item.open_datetime,
            }));
            accFrom = accOptions.find(
              (x) => x.value === paymentRes.data.acc_from_id,
            );
            accTo = accOptions.find(
              (x) => x.value === paymentRes.data.acc_to_id,
            );
            setAccountFrom(accOptions || []);
            setAccountTo(accOptions || []);
          })
          .catch((err) => console.log(err.message));
        setFormData({
          account_from: accFrom,
          account_to: accTo,
          amount: paymentRes.data.amount_paid,
          notes: paymentRes.data.note,
        });
      }
    }
    fetchData();
  }, [payment_id]);

  return (
    <div className="m-0 md:m-4 p-4 md:p-8 main-div-bg">
      <Header title="EDIT RECEIPT" />
      <form>
        <Container className="g-0 form-container" fluid="true">
          <Row xs={1} sm={1} className="p-0 justify-content-center">
            <Col md={6} sm={8} className="container-col">
              <div className="col-lg-12">
                <SelectField
                  label="Received In:"
                  name="account_to"
                  value={formData.account_to}
                  options={accountTo}
                  onChange={handleSelectChange}
                  placeholder="Received In Account"
                  compulsory={true}
                  error={errors.account_to}
                />
                <SelectField
                  label="Received From:"
                  name="account_from"
                  value={formData.account_from}
                  options={accountFrom}
                  onChange={handleSelectChange}
                  placeholder="Received From Account"
                  compulsory={true}
                  error={errors.account_from}
                />
                <DoubleField
                  label="Amount Received:"
                  name="amount"
                  value={formData.amount}
                  onChange={handleChange}
                  placeholder="Amount Received"
                  min="0"
                  step="1.00"
                  compulsory={true}
                  error={errors.amount}
                />
                <TextAreaField
                  label="Notes:"
                  name="notes"
                  value={formData.notes}
                  onChange={handleChange}
                  placeholder="Notes"
                  error={errors.notes}
                />
              </div>
            </Col>
            <Col md={2} className="container-col">
              <div className="col-lg-12">
                <div className="form-group mt-12">
                  <label className="label">
                    Bal: {formatCurrency(formData.account_to?.balance ?? 0)}
                  </label>
                </div>
                <div className="form-group mt-14">
                  <label className="label">
                    Bal: {formatCurrency(formData.account_from?.balance ?? 0)}
                  </label>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </form>
      <Row md={"auto"} className="justify-content-center pt-12">
        <Button
          margin="10px"
          padding="20px"
          text="Update"
          onClick={handleSubmit}
          disabled={loadBtn}
        />
        <Button
          margin="10px"
          padding="20px"
          text="Back"
          onClick={handleBackClick}
        />
      </Row>
    </div>
  );
};

export default EditReceipt;
